// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--YnNfP","info":"_103a151b99--info--uaKu5","avatar":"_103a151b99--avatar--pUXxj","counter":"_103a151b99--counter--AtjVJ"};